import React from "react";
import { useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import "./checkout.css";
import lawService from "./simpleAjax.js";
import customLawService from "./customAjax.js";
import transferService from "./addEPUSA.js";
import { Blocks } from "react-loader-spinner";
import evereeService from "./evereeService.js";
import createBusiness from "./createBusiness.js";
import checkForInheritGold from "./checkForInheritgold.js";

function Checkout() {
  const location = useLocation();
  const [titleAndBlurb, setTitleAndBlurb] = useState({ blurb: "", title: "" });
  //paidloading state is used to determine what message is shown to the attorney on the checkout page
  //it could show the payment link, a spinning wheel while api calls run, an error message, or an OK to close message
  const [paidLoading, setPaidLoading] = useState({
    loading: false,
    goodToClose: false,
    isError: false,
  });
  const [fieldAgent, setFieldAgent] = useState({
    phone: "",
    email: "",
    name: "",
  });
 
  //handleMessage) we embed a confido payment link into our website. When a successful purchase is made,
  //it sends a message to the window of type "pd:page_success"
  //we listen for this and when we hear it, we trigger payments to agents/attornies/updating the matter info in lawmati
  const handleMessage = async (m) => {
    if (m.data.type === "pd:page_success") {
      if (location.state.isEPSTrustPlusPurchase) {
        trustPlusEPSSuccessHandler();
      } else {
        successHandler();
      }

      window.removeEventListener("message", handleMessage);
    }
  };

  //determineAgentPaymentAmount looks at all the possible things that could affect how much we pay an agent for this referral
  //e.g. if they attend the meeting, what was purchased, how many things etc, 
  //and returns the value
  const determineAgentPaymentAmount = (isInheritGold) => {
    let simpleAmount = 300;
    if (location.state.attorneyAttend == "true") {
      simpleAmount = simpleAmount + 50;
    }
    if (isInheritGold === true) {
      simpleAmount = simpleAmount + 50;
    }

    if (location.state?.isAgentPlan === true) {
      simpleAmount = 100;
    }

    if (location.state.isWillPlan === true) {
      simpleAmount = 50;
    }
    let customAmount = 0;
    if (location.state.isWealthPurchase === true) {
      let customAmount = 400;
    }

    if (location.state.isCustom) {
      let basicBusiness = false;
      let enhancedBusiness = false;
      let advancedBusiness = false;
      let totalBasic = 0;
      let totalEnhanced = 0;
      let totalAdvanced = 0;
      if (location.state.attorneyAttend == "true") {
        customAmount = 600;
      }

      if (
        location.state.cartItems.basicCorpWealth != "0" ||
        location.state.cartItems.basicLLCWealth != "0" ||
        location.state.cartItems.basicCorp != "0" ||
        location.state.cartItems.basicLLC != "0"
      ) {
        let numberOfPurchases =
          Number(location.state.cartItems.basicCorpWealth) +
          Number(location.state.cartItems.basicLLCWealth) +
          Number(location.state.cartItems.basicCorp) +
          Number(location.state.cartItems.basicLLC);
        customAmount = customAmount + numberOfPurchases * 200;
        totalBasic = numberOfPurchases * 200;
        basicBusiness = true;
      }
      if (
        location.state.cartItems.enhancedCorpWealth != "0" ||
        location.state.cartItems.enhancedLLCWealth != "0" ||
        location.state.cartItems.enhancedCorp != "0" ||
        location.state.cartItems.enhancedLLC != "0"
      ) {
        let numberOfPurchases =
          Number(location.state.cartItems.enhancedCorpWealth) +
          Number(location.state.cartItems.enhancedLLCWealth) +
          Number(location.state.cartItems.enhancedCorp) +
          Number(location.state.cartItems.enhancedLLC);
        customAmount = customAmount + numberOfPurchases * 200;
        totalEnhanced = numberOfPurchases * 200;
        enhancedBusiness = true;
      }
      if (
        location.state.cartItems.advancedCorpWealth != "0" ||
        location.state.cartItems.advancedLLCWealth != "0" ||
        location.state.cartItems.advancedCorp != "0" ||
        location.state.cartItems.advancedLLC != "0"
      ) {
        let numberOfPurchases =
          Number(location.state.cartItems.advancedCorpWealth) +
          Number(location.state.cartItems.advancedLLCWealth) +
          Number(location.state.cartItems.advancedCorp) +
          Number(location.state.cartItems.advancedLLC);
        customAmount = customAmount + numberOfPurchases * 300;
        totalAdvanced = numberOfPurchases * 300;
        advancedBusiness = true;
      }
      if (
        location.state.paySummitAdminFee &&
        (location.state.cartItems.standaloneBuySell != "0" ||
          basicBusiness === true || // basic corporation formation - inheritguard-cart/custom
          enhancedBusiness === true ||
          advancedBusiness === true)
      ) {
        customAmount = 500 + totalAdvanced + totalEnhanced + totalBasic;
      }
    }
    let paymentObj={simpleAmount:simpleAmount,customAmount:customAmount}
    console.log(paymentObj)
    return paymentObj
  };

  ///adding event listeners to see the pd:page_success. the popstate removes the listener if they use the back button on their browser, so that 
  //we don't have two event listeners that trigger twice
  window.addEventListener("message", handleMessage);
  window.addEventListener("popstate", (event) => {
    window.removeEventListener("message", handleMessage);
  });

  //if an agent purchases a trust plus+ plan, the matter won't already exist in lawmatics (as it does when an attorney purchases something)
  //this success handler for those purchases just creates the matter and updates it with what is purchased.
  //we don't pay attornies/agents here because we don't have that info for the matter yet, because it hasn't been created
  const trustPlusEPSSuccessHandler = async () => {
    setPaidLoading((ps) => {
      let pd = { ...ps };
      pd.loading = true;
      return pd;
    });
    try {
      let newMatterResponse = await lawService.createMatter(
        location.state.trustPlusClient.firstName,
        location.state.trustPlusClient.lastName,
        location.state.trustPlusClient.email,
        location.state.trustPlusClient.phone,
        location.state.price,
        location.state.trustPlusClient.trustPlusNumber,
        location.state.notes,
      );

      await lawService.pushSimpleQuants(
        newMatterResponse.data.data.id,
        location.state.trustPlusClient.binders,
        location.state.trustPlusClient.deeds,
        location.state.trustPlusClient.assignments,
        location.state.trustPlusClient.familyPlans,
        location.state.trustPlusClient.trustPlans,
        location.state.trustPlusClient.isAgentPlan,
        location.state.trustPlusClient.ownNotary,
        location.state.trustPlusClient.lawmaticsInputString,
        location.state.trustPlusClient.actualValue,
        location.state.trustPlusClient.recordingNumber,
        location.state.trustPlusClient.deedsToBeDrafted,
        location.state.trustPlusClient.agentTrust,
        location.state.trustPlusClient.ammendments,
        location.state.trustPlusClient.notaries,
        location.state.trustPlusClient.affidavits,
        location.state.trustPlusClient.depositAmount,
        location.state.trustPlusClient.isSummer50,
        location.state.trustPlusClient.trustPlusNumber,
        location.state.agentSell ? true : false,
        location.state.trustPlusClient.attorneyReviews,
        location.state.trustPlusClient.trustPlusTag,
        location.state.attorneyAttend,
      );
      setPaidLoading((ps) => {
        let pd = { ...ps };
        pd.goodToClose = true;
        return pd;
      });
    } catch {
      setPaidLoading((ps) => {
        let pd = { ...ps };
        pd.isError = true;
        return pd;
      });
    }
  };

  //this success handler is for any purchases done by attornies/processors (NOT agents)
  //
  const successHandler = async () => {
    //set loading screen ON
    setPaidLoading((ps) => {
      let pd = { ...ps };
      pd.loading = true;
      return pd;
    });
    //string building to the correct format for spouse's name and little blurb about client
    let case_blurb = "";
    let case_title = "";
    let matterLastName = location.state.name.split(" ")[1];
    let matterFirstName = location.state.name.split(" ")[0];
    let originatingAttorneyNote = "";
    let processorNote = "";
    let agentNote = "";
    let sendNote = false;
    if (location.state.spouse != 0) {
      try {
        let spouseResponse = await customLawService.getContactById(
          location.state.spouse,
        );
        let spouseFirstname = spouseResponse.data.data.attributes.first_name;
        let spouseLastname = spouseResponse.data.data.attributes.last_name;
        if (spouseLastname == matterLastName) {
          case_blurb = `${matterFirstName} and ${spouseFirstname} ${matterLastName} Estate Planning`;
          case_title = `${matterLastName}, ${matterFirstName} and ${spouseFirstname} EP`;
        }
        if (spouseLastname != matterLastName) {
          case_blurb = `${matterFirstName} ${matterLastName} and ${spouseFirstname} ${spouseLastname} Estate Planning`;
          case_title = `${matterLastName}, ${matterFirstName} and ${spouseFirstname} ${spouseLastname} EP`;
        }
      } catch {
        case_blurb = `${matterFirstName} ${matterLastName} Estate Planning`;
        case_title = `${matterLastName}, ${matterFirstName} EP`;
      }
    }
    if (location.state.spouse === 0) {
      case_blurb = `${matterFirstName} ${matterLastName} Estate Planning`;
      case_title = `${matterLastName}, ${matterFirstName} EP`;
    }

    //areWeMarkingPayment means are we marking the custom field "payment received" in lawmatics to true. 
    //we determine this based on what they buy. Buying Some things (e.g. wealthguard plan) would make it true
    //where as others (e.g. additional deed) would not cause us to mark that true
    if (location.state.areWeMarkingPayment === true) {
      //isCustom means is it coming from the customcart
      if (location.state.isCustom === false) {
        const leadAttorneyId = location.state.leadAttorney;
        const originatingAttorneyId = location.state.originatingAttorney;
///this try catch block is for determining the processor's everee account and paying them the proper amount
///the matter's lead attorney is a "user" in lawmatics. that user has an email. That email is the same as that person's "externalId" in everee
//we use that email to send out the appropriate everee payment.
//it requries 2 api calls in everee 1 to "createPayable" and one to "requestASAPPayment"
        try {
          const processorPaymentExtenalId = `Processor Payment for ${matterFirstName} ${matterLastName} ${new Date()
            .getTime()
            .toString()}`;
          let leadAttorneyEmail =
            await customLawService.getAttorneyEmailById(leadAttorneyId);
          if (
            ///some certain processors/attornies don't get paid when their clients make purchases 
            location.state.leadAttorney != 30891 &&
            location.state.leadAttorney != 23443 &&
            location.state.leadAttorney != 22640
          ) {
            let processorAmount;
            ///attorneyTrustPLus means it's a trustguard plus+ plan that the attorney sold to the client withoug an agent's help
            if (location.state.clientObj.isAttorneyTrustPlus === false) {
              if (!location.state.isAttorneyReferral) {
                processorAmount = 100;
                if (
                  leadAttorneyId == 28778 ||
                  leadAttorneyId === originatingAttorneyId
                ) {
                  processorAmount = 200;
                }
                //isAttorneyReferral means the attorney referred the plan themself without WFG involvement
              } else if (location.state.isAttorneyReferral) {
                processorAmount = 100;
                if (leadAttorneyId === originatingAttorneyId) {
                  processorAmount = 600;
                }
              }
            } else {
              processorAmount = 500;
              if (location.state.attorneyAttend == "true") {
                processorAmount = 450;
              }
            }
            await evereeService.createPayableExternalWorkerId(
              processorPaymentExtenalId,
              leadAttorneyEmail,
              `Processor Payment for ${matterFirstName} ${matterLastName}`,
              processorAmount,
              "Simple Plan",
            );
            await evereeService.requestPaymentExternalWorkerId(
              processorPaymentExtenalId,
              leadAttorneyEmail,
            );
            processorNote = `$${processorAmount} Processor payment sent via Everee ${new Date().toDateString()};`;
            sendNote = true;
          }
        } catch {
          //general everee/payment error form in lawmatics that triggers an email
          customLawService.submitEvereeForm(
            matterFirstName,
            location.state.email,
            "Processor%20Error",
          );
          processorNote = "";
        }

        //sometimes a matter starts in the hands of one attorney and is transferred to another
        //in these cases we split the payment between both the current "lead attorney" and the "originating attorney"
        if (
          leadAttorneyId != originatingAttorneyId &&
          originatingAttorneyId != 30891 &&
          originatingAttorneyId != 23443 &&
          originatingAttorneyId != 22640
        ) {
          try {
            let originatingAttorneyAmount;
            if (!location.state.isAttorneyReferral) {
              originatingAttorneyAmount = 100;
            } else if (location.state.isAttorneyReferral) {
              originatingAttorneyAmount = 500;
            }
            const processorPaymentExtenalId = `Original Attorney Payment for ${matterFirstName} ${matterLastName} ${new Date()
              .getTime()
              .toString()}`;
            let originatingAttorneyEmail =
              await customLawService.getAttorneyEmailById(
                originatingAttorneyId,
              );
            await evereeService.createPayableExternalWorkerId(
              processorPaymentExtenalId,
              originatingAttorneyEmail,
              `Original Attorney for ${matterFirstName} ${matterLastName}`,
              originatingAttorneyAmount,
              "Simple Plan",
            );
            await evereeService.requestPaymentExternalWorkerId(
              processorPaymentExtenalId,
              originatingAttorneyEmail,
            );
            originatingAttorneyNote = `$${originatingAttorneyAmount} Originating Attorney payment sent via Everee ${new Date().toDateString()};`;
            sendNote = true;
          } catch {
            customLawService.submitEvereeForm(
              matterFirstName,
              location.state.email,
              "Originating%20Attorney%20Error",
            );
            originatingAttorneyNote = "";
          }
        }
      }

      //if they have a field agent attached to the matter, we determine the agent's everee account (or create one for them if they don't have one)
      //and determine the correct payment amount and pay them via everee
      //we take the field agent's name, phone number, and email and seach everee on all three to see if they have an active account
      if (
        location.state.fieldAgent != 0 &&
        location.state.isStratReport != true
      ) {
        let fieldAgentPhone;
        let fieldAgentEmail;
        let fieldAgentFullName;
        let fieldAgentFirstName;
        let fieldAgentLastName;
        let phoneResponse;
        let emailResponse;
        let nameResponse;
        let isSelfAgentPlan = null;
        if (location.state.isCustom === false) {
          if (
            location.state.fieldAgent === location.state.contactId &&
            location.state?.isAgentPlan === true
          ) {
            isSelfAgentPlan = true;
          } else {
            isSelfAgentPlan = false;
          }
        }
        ///getting the email phone and name, so we can search everee
        let isInheritGold = false;
        try {
          let fieldAgentResponse = await customLawService.getContactById(
            location.state.fieldAgent,
          );

          fieldAgentPhone = fieldAgentResponse.data.data.attributes.phone;
          fieldAgentPhone = fieldAgentPhone.replace(/\D/g, "");
          if (fieldAgentPhone.length === 11 && fieldAgentPhone[0] == 1) {
            fieldAgentPhone = fieldAgentPhone.slice(1);
          }

          fieldAgentEmail = fieldAgentResponse.data.data.attributes.email;
          fieldAgentFirstName =
            fieldAgentResponse.data.data.attributes.first_name;
          fieldAgentLastName =
            fieldAgentResponse.data.data.attributes.last_name;
          let customFields =
            fieldAgentResponse.data.data.attributes.custom_fields;
          customFields.forEach(async (element) => {
            if (element.id === "470160" && element.value === true) {
              isInheritGold = true;
            } else if (element.id === "470160" && element.value === false) {
              isInheritGold = await checkForInheritGold(
                fieldAgentResponse,
                location.state.areWeMarkingPayment,
                matterFirstName,
                location.state.email,
              );
            }
          });
          ///determining payment amount and searching evere for a corresponding worker
          let paymentObj=  determineAgentPaymentAmount(isInheritGold)
          let simpleAmount=paymentObj.simpleAmount
          let customAmount = paymentObj.customAmount
          phoneResponse = await evereeService.searchWorker(fieldAgentPhone);
          emailResponse = await evereeService.searchWorker(fieldAgentEmail);
          nameResponse = await evereeService.searchWorker(fieldAgentFullName);
          let workerIdArr = [];
          let activeWorkerIds = [];
          let nameWorkerIds = [];
          let uniqueWorkerIds = [];

          //sometimes we get more than one worker in everee back when we search
          //here we collect them all and see if any of the accounts are "active"
          //if more than one are active, or multiple are in active, or if we only have a match on Name and not email or phone, 
          // //it errors out and we message support
          //if we can't find anyone, we will create an everee account for them
          phoneResponse.data.items.forEach((element) => {
            const workerId = element.workerId;
            workerIdArr.push(workerId);
          });
          emailResponse.data.items.forEach((element) => {
            const workerId = element.workerId;
            workerIdArr.push(workerId);
          });
          nameResponse.data.items.forEach((element) => {
            const workerId = element.workerId;
            nameWorkerIds.push(workerId);
          });
          uniqueWorkerIds = [...new Set(workerIdArr)];

          for (let i = 0; i < uniqueWorkerIds.length; i++) {
            const currentWorkerId = uniqueWorkerIds[i];
            const workerObj =
              await evereeService.getWorkerById(currentWorkerId);
            if (workerObj.data.lifecycleStatus === "ACTIVE") {
              activeWorkerIds.push(currentWorkerId);
            }
          }

          if (activeWorkerIds.length < 1 && uniqueWorkerIds.length > 1) {
            customLawService.submitEvereeForm(
              matterFirstName,
              location.state.email,
              "Multiple%20Inactive%20Accounts",
            );
          } 
          
          //checking that we need to make an account
          else if (
            activeWorkerIds.length < 1 &&
            uniqueWorkerIds.length === 0
          ) {
            if (nameWorkerIds.length > 0) {
              customLawService.submitEvereeForm(
                matterFirstName,
                location.state.email,
                "Matched%20on%20Name%20Only",
              );
            } else {
              if (
                location.state?.agentFeeWaved === false ||
                isSelfAgentPlan === false
              ) 
              //assuming the agent did not wave their fee or it is not an agent referring themself, we create the everee account and pay the worker
              {
                const newEvereeWorkerResponse =
                  await evereeService.createWorker(
                    fieldAgentFirstName,
                    fieldAgentLastName,
                    fieldAgentPhone,
                    fieldAgentEmail,
                  );
                const newWorkerId = newEvereeWorkerResponse.data.workerId;
                const externalId = `${case_blurb} ${new Date()
                  .getTime()
                  .toString()}`;
                 //#region OldDetermine agent fee   
                // let simpleAmount = 300;
                // if (location.state.attorneyAttend == "true") {
                //   simpleAmount = simpleAmount + 50;
                // }
                // if (isInheritGold === true) {
                //   simpleAmount = simpleAmount + 50;
                // }

                // if (location.state?.isAgentPlan === true) {
                //   simpleAmount = 100;
                // }

                // if (location.state.isWillPlan === true) {
                //   simpleAmount = 50;
                // }
                // let customAmount = 0;
                // if (location.state.isWealthPurchase === true) {
                //   let customAmount = 400;
                // }

                // if (location.state.isCustom) {
                //   let basicBusiness = false;
                //   let enhancedBusiness = false;
                //   let advancedBusiness = false;
                //   let totalBasic = 0;
                //   let totalEnhanced = 0;
                //   let totalAdvanced = 0;
                //   if (location.state.attorneyAttend == "true") {
                //     customAmount = 600;
                //   }

                //   if (
                //     location.state.cartItems.basicCorpWealth != "0" ||
                //     location.state.cartItems.basicLLCWealth != "0" ||
                //     location.state.cartItems.basicCorp != "0" ||
                //     location.state.cartItems.basicLLC != "0"
                //   ) {
                //     let numberOfPurchases =
                //       Number(location.state.cartItems.basicCorpWealth) +
                //       Number(location.state.cartItems.basicLLCWealth) +
                //       Number(location.state.cartItems.basicCorp) +
                //       Number(location.state.cartItems.basicLLC);
                //     customAmount = customAmount + numberOfPurchases * 200;
                //     totalBasic = numberOfPurchases * 200;
                //     basicBusiness = true;
                //   }
                //   if (
                //     location.state.cartItems.enhancedCorpWealth != "0" ||
                //     location.state.cartItems.enhancedLLCWealth != "0" ||
                //     location.state.cartItems.enhancedCorp != "0" ||
                //     location.state.cartItems.enhancedLLC != "0"
                //   ) {
                //     let numberOfPurchases =
                //       Number(location.state.cartItems.enhancedCorpWealth) +
                //       Number(location.state.cartItems.enhancedLLCWealth) +
                //       Number(location.state.cartItems.enhancedCorp) +
                //       Number(location.state.cartItems.enhancedLLC);
                //     customAmount = customAmount + numberOfPurchases * 200;
                //     totalEnhanced = numberOfPurchases * 200;
                //     enhancedBusiness = true;
                //   }
                //   if (
                //     location.state.cartItems.advancedCorpWealth != "0" ||
                //     location.state.cartItems.advancedLLCWealth != "0" ||
                //     location.state.cartItems.advancedCorp != "0" ||
                //     location.state.cartItems.advancedLLC != "0"
                //   ) {
                //     let numberOfPurchases =
                //       Number(location.state.cartItems.advancedCorpWealth) +
                //       Number(location.state.cartItems.advancedLLCWealth) +
                //       Number(location.state.cartItems.advancedCorp) +
                //       Number(location.state.cartItems.advancedLLC);
                //     customAmount = customAmount + numberOfPurchases * 300;
                //     totalAdvanced = numberOfPurchases * 300;
                //     advancedBusiness = true;
                //   }
                //   if (
                //     location.state.paySummitAdminFee &&
                //     (location.state.cartItems.standaloneBuySell != "0" ||
                //       basicBusiness === true ||
                //       enhancedBusiness === true ||
                //       advancedBusiness === true)
                //   ) {
                //     customAmount =
                //       500 + totalAdvanced + totalEnhanced + totalBasic;
                //   }
                // }
//#endregion
                

                  const label = `Agent Admin Fee for ${
                  location.state.name.split(" ")[0]
                } ${location.state.name.split(" ")[1]}`;
                const type =
                  location.state.isCustom === true
                    ? "Custom Plan"
                    : "Simple Plan";
                const amount =
                  location.state.isCustom === true
                    ? customAmount
                    : simpleAmount;

                await evereeService.createPayable(
                  externalId,
                  newWorkerId,
                  label,
                  amount,
                  type,
                );
                await evereeService.requestPayment(externalId, newWorkerId);
                console.log("amount", amount);
                agentNote = `$${
                  location.state.isCustom === true ? amount : simpleAmount
                } Agent payment sent via Everee ${new Date().toDateString()};`;
                sendNote = true;
              }
            }
          } else if (activeWorkerIds.length > 1) {
            customLawService.submitEvereeForm(
              matterFirstName,
              location.state.email,
              "Two%20Active%20Accounts",
            );
          } 
          
        //here is if we only have one active account for the worker after all the searching and flitering. So we pay them here.
          else {
            let evereeIdToPay;
            if (activeWorkerIds.length === 1) {
              evereeIdToPay = activeWorkerIds[0];
            } else if (uniqueWorkerIds.length === 1) {
              evereeIdToPay = uniqueWorkerIds[0];
            }
            if (
              location.state?.agentFeeWaved === false ||
              isSelfAgentPlan === false
            ) {
              const externalId = `${case_blurb} ${new Date()
                .getTime()
                .toString()}`;
//#region OldDetermine agent fee  
              // if (location.state.attorneyAttend == "true") {
              //   simpleAmount = simpleAmount + 50;
              // }
              // if (isInheritGold === true) {
              //   simpleAmount = simpleAmount + 50;
              // }
              // if (location.state?.isAgentPlan === true) {
              //   simpleAmount = 100;
              // }

              // if (location.state.isWillPlan === true) {
              //   simpleAmount = 50;
              // }


              // if (location.state.isCustom) {
              //   let basicBusiness = false;
              //   let enhancedBusiness = false;
              //   let advancedBusiness = false;
              //   let totalBasic = 0;
              //   let totalEnhanced = 0;
              //   let totalAdvanced = 0;
              //   if (location.state.attorneyAttend == "true") {
              //     customAmount = 600;
              //   }

              //   if (
              //     location.state.cartItems.basicCorpWealth != "0" ||
              //     location.state.cartItems.basicLLCWealth != "0" ||
              //     location.state.cartItems.basicCorp != "0" ||
              //     location.state.cartItems.basicLLC != "0"
              //   ) {
              //     let numberOfPurchases =
              //       Number(location.state.cartItems.basicCorpWealth) +
              //       Number(location.state.cartItems.basicLLCWealth) +
              //       Number(location.state.cartItems.basicCorp) +
              //       Number(location.state.cartItems.basicLLC);
              //     customAmount = customAmount + numberOfPurchases * 200;
              //     totalBasic = numberOfPurchases * 200;
              //     basicBusiness = true;
              //   }
              //   if (
              //     location.state.cartItems.enhancedCorpWealth != "0" ||
              //     location.state.cartItems.enhancedLLCWealth != "0" ||
              //     location.state.cartItems.enhancedCorp != "0" ||
              //     location.state.cartItems.enhancedLLC != "0"
              //   ) {
              //     let numberOfPurchases =
              //       Number(location.state.cartItems.enhancedCorpWealth) +
              //       Number(location.state.cartItems.enhancedLLCWealth) +
              //       Number(location.state.cartItems.enhancedCorp) +
              //       Number(location.state.cartItems.enhancedLLC);
              //     customAmount = customAmount + numberOfPurchases * 200;
              //     totalEnhanced = numberOfPurchases * 200;
              //     enhancedBusiness = true;
              //   }
              //   if (
              //     location.state.cartItems.advancedCorpWealth != "0" ||
              //     location.state.cartItems.advancedLLCWealth != "0" ||
              //     location.state.cartItems.advancedCorp != "0" ||
              //     location.state.cartItems.advancedLLC != "0"
              //   ) {
              //     let numberOfPurchases =
              //       Number(location.state.cartItems.advancedCorpWealth) +
              //       Number(location.state.cartItems.advancedLLCWealth) +
              //       Number(location.state.cartItems.advancedCorp) +
              //       Number(location.state.cartItems.advancedLLC);
              //     customAmount = customAmount + numberOfPurchases * 300;
              //     totalAdvanced = numberOfPurchases * 300;
              //     advancedBusiness = true;
              //   }
              //   if (
              //     location.state.paySummitAdminFee &&
              //     (location.state.cartItems.standaloneBuySell != "0" ||
              //       basicBusiness === true ||
              //       enhancedBusiness === true ||
              //       advancedBusiness === true)
              //   ) {
              //     customAmount =
              //       500 + totalAdvanced + totalEnhanced + totalBasic;
              //   }
              // }
              //#endregion
   const label = `Agent Admin Fee for ${
                location.state.name.split(" ")[0]
              } ${location.state.name.split(" ")[1]}`;
              const type =
                location.state.isCustom === true
                  ? "Custom Plan"
                  : "Simple Plan";
              let customAmount = 0;
              if (location.state.isWealthPurchase === true) {
                let customAmount = 400;
              }
              const amount =
                location.state.isCustom === true ? customAmount : simpleAmount;

              await evereeService.createPayable(
                externalId,
                evereeIdToPay,
                label,
                amount,
                type,
              );
              await evereeService.requestPayment(externalId, evereeIdToPay);
              console.log("amount", amount);
              agentNote = `$${
                location.state.isCustom === true ? customAmount : simpleAmount
              } Agent payment sent via Everee ${new Date().toDateString()};`;

              sendNote = true;
            }
          }
        } catch {
          customLawService.submitEvereeForm(
            matterFirstName,
            location.state.email,
            "Field%20Agent%20Error",
          );
          agentNote = "";
        }
        if (sendNote === true) {
          try {
            const clientId = location.state.isCustom
              ? location.state.pushQuantObj.clientId
              : location.state.clientObj.clientId;
            const paymentNote = `${processorNote} ${originatingAttorneyNote} ${agentNote}`;
            await customLawService.submitNote(clientId, paymentNote);
          } catch {
            customLawService.submitEvereeForm(
              matterFirstName,
              location.state.email,
              "Payment%20Note%20Error",
            );
          }
        }
      }
    }
///here we check if it came from the simple or custom cart and then update the matter accorndingly (what they purchased, which attorney did the payment, add the blurb, etc)
//this is simple
    if (location.state.isCustom === false) {
      if (location.state.clientObj.clientId) {
        if (location.state.areWeMarkingPayment === true) {
          lawService
            .markPayment(location.state.clientObj.clientId)
            .then((r) => {
              console.log("mark payment", r);
            })
            .catch((e) => {
              console.log("mark jpaymetn,", e);
            });
          //   .then(alert("payment Marked"))
          //   .catch(alert("error marking payment"))
          lawService.detachTags(location.state.clientObj.clientId, [
            "Custom Plan",
          ]);
          lawService
            .pushSimpleQuants(
              location.state.clientObj.clientId,
              location.state.clientObj.binders,
              location.state.clientObj.deeds,
              location.state.clientObj.assignments,
              location.state.clientObj.familyPlans,
              location.state.clientObj.trustPlans,
              location.state.clientObj.isAgentPlan,
              location.state.clientObj.ownNotary,
              location.state.clientObj.lawmaticsInputString,
              location.state.clientObj.actualValue,
              location.state.clientObj.recordingNumber,
              location.state.clientObj.deedsToBeDrafted,
              location.state.clientObj.agentTrust,
              location.state.clientObj.ammendments,
              location.state.clientObj.notaries,
              location.state.clientObj.affidavits,
              location.state.clientObj.depositAmount,
              location.state.clientObj.isSummer50,
              location.state.clientObj.trustPlusPlans,
              location.state.agentSell ? true : false,
              location.state.clientObj.attorneyReviews,
              location.state.clientObj.trustPlusTag,
              location.state.attorneyAttend,
            )
            .then((r) => {
              ignUpdateSuccess(
                location.state.clientObj.clientId,
                location.state.notes,
                location.state.price,
              );
              // setPaidLoading((ps) => {
              //   let pd = {...ps}
              //   pd.goodToClose=true
              //   return pd;
              // });;
            })
            .catch((e) => {
              setPaidLoading((ps) => {
                let pd = { ...ps };
                pd.isError = true;
                return pd;
              });
            });
          lawService
            .changeAttorney(
              location.state.clientObj.clientId,
              location.state.clientObj.leadAttorneyId,
            )
            .then((r) => {
              console.log("change attorney", r);
            })
            .catch((e) => {
              console.log("changeATtorye,", e);
            });
          customLawService
            .changeAttributes(
              location.state.clientObj.clientId,
              "case_blurb",
              case_blurb,
            )
            .then((r) => {
              console.log("blurb", r);
            })
            .catch((e) => {
              console.log("blurb", e);
            });
          customLawService
            .changeAttributes(
              location.state.clientObj.clientId,
              "case_title",
              case_title,
            )
            .then((r) => {
              console.log("title", r);
            })
            .catch((e) => {
              console.log("title", e);
            });
        } else if (location.state.areWeMarkingPayment === false) {
          lawService.detachTags(location.state.clientObj.clientId, [
            "Custom Plan",
          ]);
          lawService
            .pushSimpleQuants(
              location.state.clientObj.clientId,
              location.state.clientObj.binders,
              location.state.clientObj.deeds,
              location.state.clientObj.assignments,
              location.state.clientObj.familyPlans,
              location.state.clientObj.trustPlans,
              location.state.clientObj.isAgentPlan,
              location.state.clientObj.ownNotary,
              location.state.clientObj.lawmaticsInputString,
              location.state.clientObj.actualValue,
              location.state.clientObj.recordingNumber,
              location.state.clientObj.deedsToBeDrafted,
              location.state.clientObj.agentTrust,
              location.state.clientObj.ammendments,
              location.state.clientObj.notaries,
              location.state.clientObj.affidavits,
              location.state.clientObj.depositAmount,
              location.state.clientObj.isSummer50,
              location.state.clientObj.trustPlusPlans,
              location.state.agentSell ? true : false,
              location.state.clientObj.attorneyReviews,
              location.state.clientObj.trustPlusTag,
              location.state.attorneyAttend,
            )
            .then((r) => {
              const clientFirstName = location.state.name.split(" ")[0];
              customLawService
                .submitDepositForm(
                  location.state.email,
                  clientFirstName,
                  "Simple",
                  false,
                )
                .then((r) =>
                  setPaidLoading((ps) => {
                    let pd = { ...ps };
                    pd.goodToClose = true;
                    return pd;
                  }),
                )
                .catch((e) => {
                  setPaidLoading((ps) => {
                    let pd = { ...ps };
                    pd.isError = true;
                    return pd;
                  });
                });
            })
            .catch((e) => {
              setPaidLoading((ps) => {
                let pd = { ...ps };
                pd.isError = true;
                return pd;
              });
            });
          lawService
            .changeAttorney(
              location.state.clientObj.clientId,
              location.state.clientObj.leadAttorneyId,
            )
            .then((r) => {
              console.log("change attorney", r);
            })
            .catch((e) => {
              console.log("changeATtorye,", e);
            });
          customLawService
            .changeAttributes(
              location.state.clientObj.clientId,
              "case_blurb",
              case_blurb,
            )
            .then((r) => {
              console.log("blurb", r);
            })
            .catch((e) => {
              console.log("blurb", e);
            });
          customLawService
            .changeAttributes(
              location.state.clientObj.clientId,
              "case_title",
              case_title,
            )
            .then((r) => {
              console.log("title", r);
            })
            .catch((e) => {
              console.log("title", e);
            });
        }
      }

      ///here we check if it came from the simple or custom cart and then update the matter accorndingly (what they purchased, which attorney did the payment, add the blurb, etc)
//this is custom
    } else if (location.state.isCustom === true) {
      if (location.state.pushQuantObj.clientId) {
        try {
          ///if it's a business purchase, and the business matter doesn't exist yet we create a new business matter with a temporary name
          if (location.state.createNewBusiness === true) {
            createTempBusinessMatter(
              "ign",
              location.state.contactId,
              location.state.fieldAgent,
            );
          }
          if (
            location.state.epusaCompanyMatterId === false &&
            location.state.isBusinessPurchase === true
          ) {
            if (location.state.epusaContactId != 0) {
              createTempBusinessMatter(
                "epusa",
                location.state.epusaContactId,
                0,
              );
              ///for custom plans, we recreate the matter in the EPUSA lawmatics account
              //or update it if it already exists
            } else if (location.state.epusaContactId === 0) {
              let contactObj = {
                first_name: location.state.clientFirstName,
                last_name: location.state.clientLastName,
                email: location.state.email,
                phone: location.state.phone,
              };
              let newEPUSAContactResponse =
                await customLawService.createEPUSAContact(contactObj);

              const newEPUSAContactId = newEPUSAContactResponse.data.data.id;
              createTempBusinessMatter("epusa", newEPUSAContactId, 0);
            }
          }
////////////company matter already exists in lawmatics, so marking payment for that matter
          if (location.state.ignCompanyMatterId != 0) {
            try {
              customLawService.markPayment(location.state.ignCompanyMatterId);
              let requestObj = location.state.pushQuantObj;
              requestObj.id = location.state.ignCompanyMatterId;
              requestObj.actualValue = location.state.pushQuantObj.totalToPush;
              requestObj.agentAttend = location.state.attorneyAttend;
              lawService.detachTags(location.state.ignCompanyMatterId, [
                "Simple Plan",
              ]);
              customLawService.pushCustomQuants2(requestObj);
            } catch {
              setPaidLoading((ps) => {
                let pd = { ...ps };
                pd.isError = true;
                return pd;
              });
            }
          }
          ///if there is an exisitng matter in EPUSA lawmatics for this client, update it instead of creating a new one
          if (location.state.epusaCompanyMatterId != false) {
            const customFieldObj = {
              coCounselId: null,
              CRUT: 0,
              CMT: 0,
              DAPT: 0,
              familyGuardPlans: 0,
              LAPT: 0,
              SNTwRLT: 0,
              LLCWealth: location.state.cartItems.LLCWealth,
              LLCCorp: location.state.cartItems.LLCFormation,
              MAPT: 0,
              RLTwSNT: 0,
              wealthGuardPlans: 0,
              IDGT: 0,
              powerOfAttorneyI: 0,
              powerOfAttorneyJ: 0,
              familyFoundationOperating: 0,
              familyFoundationNonOperating: 0,
              corporateKit: location.state.cartItems.corporateKit,
              llcName: "",
            };
            customLawService
              .updateEPUSAMatter(
                location.state.epusaCompanyMatterId,
                location.state.businessValue,
                customFieldObj,
              )
              .then((r) => {
                transferService.onEPUSASuccess(
                  location.state.epusaCompanyMatterId,
                  customLawService,
                  location.state.notes,
                  location.state.businessValue,
                  setPaidLoading,
                );
              })
              .catch((e) => {
                setPaidLoading((ps) => {
                  let pd = { ...ps };
                  pd.isError = true;
                  return pd;
                });
              });
          }
          if (
            location.state.areWeMarkingPayment === true &&
            location.state.isEstatePurchase === true
          ) {
            customLawService
              .markPayment(location.state.pushQuantObj.clientId)
              .then((r) => {
                console.log("mark payment", r);
              })
              .catch((e) => {
                setPaidLoading((ps) => {
                  let pd = { ...ps };
                  pd.isError = true;
                  return pd;
                });
              });

            let requestObj = location.state.pushQuantObj;
            requestObj.actualValue =
              location.state.pushQuantObj.totalToPush -
              location.state.businessValue;
            lawService.detachTags(location.state.pushQuantObj.clientId, [
              "Simple Plan",
            ]);
            requestObj.agentAttend = location.state.attorneyAttend;
            customLawService
              .pushCustomQuants2(requestObj)
              .then((r) => {
                transferService.transferToEpusa(
                  location.state.pushQuantObj.clientId,
                  customLawService,
                  location.state.notes,
                  location.state.price - location.state.businessValue,
                  location.state.isEPUSA,
                  location.state.pushQuantObj.totalToPush,
                  setPaidLoading,
                );
              })
              .catch((e) => {
                setPaidLoading((ps) => {
                  let pd = { ...ps };
                  pd.isError = true;
                  return pd;
                });
              });
            customLawService
              .changeAttorney(
                location.state.pushQuantObj.clientId,
                location.state.leadAttorneyId,
              )
              .then((r) => {
                console.log("change attorney", r);
              })
              .catch((e) => {
                console.log("changeATtorye,", e);
              });
            customLawService
              .changeAttributes(
                location.state.pushQuantObj.clientId,
                "case_blurb",
                case_blurb,
              )
              .then((r) => {
                console.log("blurb", r);
              })
              .catch((e) => {
                console.log("blurb", e);
              });
            customLawService
              .changeAttributes(
                location.state.pushQuantObj.clientId,
                "case_title",
                case_title,
              )
              .then((r) => {
                console.log("title", r);
              })
              .catch((e) => {
                console.log("title", e);
              });

              //updating matter without marking payment as true
          } else if (location.state.areWeMarkingPayment === false) {

            let requestObj = location.state.pushQuantObj;
            requestObj.actualValue = location.state.pushQuantObj.totalToPush;
            requestObj.agentAttend = location.state.attorneyAttend;
            lawService.detachTags(location.state.pushQuantObj.clientId, [
              "Simple Plan",
            ]);
            customLawService
              .pushCustomQuants2(requestObj)
              .then((r) => {
                const clientFirstName = location.state.name.split(" ")[0];
                if (location.state.pushQuantObj.depositAmount > 0) {
                  customLawService
                    .submitDepositForm(
                      location.state.email,
                      clientFirstName,
                      "Custom",
                      false,
                    )
                    .then((r) =>
                      setPaidLoading((ps) => {
                        let pd = { ...ps };
                        pd.goodToClose = true;
                        return pd;
                      }),
                    )
                    .catch((e) => {
                      setPaidLoading((ps) => {
                        let pd = { ...ps };
                        pd.isError = true;
                        return pd;
                      });
                    });
                } else {
                  setPaidLoading((ps) => {
                    let pd = { ...ps };
                    pd.goodToClose = true;
                    return pd;
                  });
                }
              })
              .catch((e) => {
                setPaidLoading((ps) => {
                  let pd = { ...ps };
                  pd.isError = true;
                  return pd;
                });
              });
            customLawService
              .changeAttorney(
                location.state.pushQuantObj.clientId,
                location.state.leadAttorneyId,
              )
              .then((r) => {
                console.log("change attorney", r);
              })
              .catch((e) => {
                console.log("changeATtorye,", e);
              });
            customLawService
              .changeAttributes(
                location.state.pushQuantObj.clientId,
                "case_blurb",
                case_blurb,
              )
              .then((r) => {
                console.log("blurb", r);
              })
              .catch((e) => {
                console.log("blurb", e);
              });
            customLawService
              .changeAttributes(
                location.state.pushQuantObj.clientId,
                "case_title",
                case_title,
              )
              .then((r) => {
                console.log("title", r);
              })
              .catch((e) => {
                console.log("title", e);
              });
          }
        } catch {
          setPaidLoading((ps) => {
            let pd = { ...ps };
            pd.isError = true;
            return pd;
          });
        }
      }
    }
  };

  //for simple plans, we add a time entry/transaction and deposit money into the trust account of their matter
  const ignUpdateSuccess = (matterId, description, amount) => {
    const safeDescription = encodeURIComponent(description);
    let transactionObj = {
      transaction_type: "credit",
      bank_account_type: "trust",
      payment_method: "credit_card",
      executed_at: new Date(),
      amount_cents: amount,
      note: safeDescription,
      transactable_id: matterId,
      transactable_type: "Prospect",
    };
    let timeEntryObj = {
      description: safeDescription,
      running_since: null,
      started_at: new Date(),
      completed_at: new Date(),
      billable: true,
      is_flat_fee: true,
      rate_flat_fee: amount,
      created_by_id: "23453",
      user_id: "23453",
      contactable_id: matterId,
      contactable_type: "matter",
    };

    lawService
      .createIGNTransaction(transactionObj)
      .then((r) => {
        console.log(r);
      })
      .catch((e) => {
        setPaidLoading((ps) => {
          let pd = { ...ps };
          pd.isError = true;
          return pd;
        });
      });
    lawService
      .createIGNTimeEntry(timeEntryObj)
      .then((r) => {
        console.log(r);
        let newTimeEntryId = r.data.data.id;
        let newEntryObj = {
          matterId: matterId,
          rate: amount,
          timeEntryId: newTimeEntryId,
        };
        lawService
          .updateIGNTimeEntry(newEntryObj)
          .then((r) => {
            console.log(r);
            setPaidLoading((ps) => {
              let pd = { ...ps };
              pd.goodToClose = true;
              return pd;
            });
          })
          .catch((e) => {
            setPaidLoading((ps) => {
              let pd = { ...ps };
              pd.isError = true;
              return pd;
            });
          });
      })
      .catch((e) => {
        setPaidLoading((ps) => {
          let pd = { ...ps };
          pd.isError = true;
          return pd;
        });
      });
  };

  ///this is for business purchases where the business matter doesn't yet exist in lawmatics. 
  ///maybe a personal, estate planning matter exists, but they want to do some business planning,
  //so we crete a business matter for them, then the attorney will fill out a form in lawmatics to do some changes to it.
  const createTempBusinessMatter = async (
    finorIgn,
    contactToPush,
    fieldAgentId,
  ) => {
    try {
      const comp = {
        companyName: `${location.state.clientName} Business`,
      };
      const companyMatterId = await createBusiness(
        comp,
        finorIgn,
        contactToPush,
        fieldAgentId,
        setPaidLoading,
      );
      if (finorIgn === "ign") {
        let requestObj = location.state.cartItems;
        requestObj.clientId = companyMatterId;
        requestObj.actualValue = location.state.businessValue;
        requestObj.agentAttend = location.state.attorneyAttend;
        customLawService.pushCustomQuants2(requestObj);
        // customLawService.pushCustomQuants(
        //   companyMatterId,
        //   0,
        //   0,
        //   0,
        //   0,
        //   location.state.cartItems.LLCFormation,
        //   location.state.cartItems.LLCWealth,
        //   0,
        //   0,
        //   0,
        //   0,
        //   0,
        //   0,
        //   0,
        //   0,
        //   0,
        //   location.state.notes,
        //   location.state.businessValue,
        //   0,
        //   location.state.pushQuantObj.waveFee,
        //   0,
        //   0,
        //   0,
        //   location.state.corporateKit,
        //   0,
        //   0,
        //   0,
        //   0,
        //   0,
        //   0,
        //   0,
        //   0,
        //   location.state.cartItems.trademarkApp,
        //   location.state.cartItems.trademarkClassFee,
        //   0,
        //   0,
        //   0,
        //   0,
        //   0,
        //   0,
        //   0,
        //   0,
        //   location.state.cartItems.basicCorp,
        //   location.state.cartItems.basicLLC,
        //   location.state.cartItems.basicCorpWealth,
        //   location.state.cartItems.basicLLCWealth,
        //   location.state.cartItems.enchancedCorp,
        //   location.state.cartItems.enhancedLLC,
        //   location.state.cartItems.enhancedCorpWealth,
        //   location.state.cartItems.enhancedLLCWealth,
        //   location.state.cartItems.advancedCorp,
        //   location.state.cartItems.advancedLLC,
        //   location.state.cartItems.advancedCorpWealth,
        //   location.state.cartItems.advancedLLCWealth,
        //   location.state.pushQuantObj.strategyReport,
        //   location.state.pushQuantObj.nonCrisis,
        //   location.state.pushQuantObj.crisis,
        //   location.state.pushQuantObj.platFunding,
        //   location.state.pushQuantObj.premFundingAst
        // );

        customLawService.changeAttorney(
          companyMatterId,
          location.state.leadAttorneyId,
        );
        customLawService.markPayment(companyMatterId);
      } else if (finorIgn === "epusa") {
        const customFieldObj = {
          coCounselId: null,
          CRUT: 0,
          CMT: 0,
          DAPT: 0,
          familyGuardPlans: 0,
          LAPT: 0,
          SNTwRLT: 0,
          LLCWealth: location.state.cartItems.LLCWealth,
          LLCCorp: location.state.cartItems.LLCFormation,
          MAPT: 0,
          RLTwSNT: 0,
          wealthGuardPlans: 0,
          IDGT: 0,
          powerOfAttorneyI: 0,
          powerOfAttorneyJ: 0,
          familyFoundationOperating: 0,
          familyFoundationNonOperating: 0,
          corporateKit: location.state.cartItems.corporateKit,
          llcName: "",
        };
        customLawService.updateEPUSAMatter(
          companyMatterId,
          location.state.businessValue,
          customFieldObj,
        );

        transferService.onEPUSASuccess(
          companyMatterId,
          customLawService,
          location.state.notes,
          location.state.businessValue,
          setPaidLoading,
        );
      }
    } catch {
      setPaidLoading((ps) => {
        let pd = { ...ps };
        pd.isError = true;
        return pd;
      });
    }
  };

  return (
    <>
      
      {!paidLoading.loading && (
        <div className="checkoutDiv">
          {!location.state.isCustom &&
            !location.state.isEPSTrustPlusPurchase && (
              <iframe
                style={{ width: "1000px", height: "1000px" }}
                //for testing fake purchase, comment out first src and uncomment second src
                src={`https://pay.confidolegal.com/standing-link/5e6c3a6d-e79d-49dc-935c-21de9740d111?amount=${location.state.price}&clientNotes=${location.state.notes}`}
                //src={`https://pay.sandbox.gravity-legal.com/standing-link/a4f08084-6dc5-449d-9e6b-98ff426057d5?amount=${location.state.price}&clientNotes=${location.state.notes}`}
              ></iframe>
            )}
          {location.state.isCustom &&
            !location.state.isEPSTrustPlusPurchase && (
              <iframe
                style={{ width: "1000px", height: "1000px" }}
                // DO NOT USE src={`https://pay.gravity-legal.com/standing-link/dadc4579-a873-4557-8531-0e6f6d6542a4?amount=${location.state.price}&clientNotes=${location.state.notes}`}
                //src={`https://pay.sandbox.gravity-legal.com/standing-link/a4f08084-6dc5-449d-9e6b-98ff426057d5?amount=${location.state.price}&clientNotes=${location.state.notes}`}
                src={`https://pay.confidolegal.com/standing-link/49752091-e2ea-40c9-b8a6-a261aacee94e?amount=${location.state.price}&clientNotes=${location.state.notes}`}
              ></iframe>
            )}
          {location.state.isEPSTrustPlusPurchase && (
            <iframe
              style={{ width: "1000px", height: "1000px" }}
              src={`https://pay.confidolegal.com/standing-link/5e6c3a6d-e79d-49dc-935c-21de9740d111?amount=${location.state.price}&clientNotes=${location.state.notes}`}
              // src={`https://pay.sandbox.gravity-legal.com/standing-link/a4f08084-6dc5-449d-9e6b-98ff426057d5?amount=${location.state.price}&clientNotes=${location.state.notes}`}
            ></iframe>
          )}
        </div>
      )}
      {paidLoading.loading && (
        <div className="checkoutDiv">
          {!paidLoading.goodToClose && (
            <div style={{ "margin-left": "30%" }}>
              <Blocks
                height="250"
                width="250"
                color="#4fa94d"
                ariaLabel="blocks-loading"
                wrapperStyle={{}}
                wrapperClass="blocks-wrapper"
                visible={true}
              />
            </div>
          )}
          {!paidLoading.goodToClose && (
            <h3>
              Payment Received and Confirmed. Please do not close the window.
            </h3>
          )}
          {paidLoading.goodToClose && !paidLoading.isError && (
            <h3>Data transfer complete; you are free to close the window</h3>
          )}
          {paidLoading.isError && (
            <h3>
              There has been a Lawmatics error. Payment was still processed.
              Please contact support for more information.
            </h3>
          )}
        </div>
      )}
    </>
  );
}

export default Checkout;
